module.exports = __webpack_public_path__ + "static/media/3-Spades.63f62c03.svg";